import { render, staticRenderFns } from "./monitoring.vue?vue&type=template&id=2fc6a23a&scoped=true&"
import script from "./monitoring.vue?vue&type=script&lang=js&"
export * from "./monitoring.vue?vue&type=script&lang=js&"
import style0 from "./monitoring.vue?vue&type=style&index=0&id=2fc6a23a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc6a23a",
  null
  
)

component.options.__file = "monitoring.vue"
export default component.exports